<!--
 * @Autor: Ruohong Yu
 * @Date: 2021-11-27 16:40:05
 * @LastEditors: Haiting Zhao
 * @LastEditTime: 2021-12-19 13:11:09
 * @Description: 日志
 * @FilePath: \Management-of-Scientific-Research-in-Universities-Front\src\views\systemmanage\Log.vue
-->

<template>
  <div>
    <!-- 面包屑导航区 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ name:'WorkPlace' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>系统管理</el-breadcrumb-item>
      <el-breadcrumb-item>日志审计</el-breadcrumb-item>
    </el-breadcrumb>

    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="登录日志" name="first">
        <login-log />
      </el-tab-pane>
      <el-tab-pane label="操作日志" name="second">
        <oper-log />
      </el-tab-pane>
      <el-tab-pane label="系统日志" name="third">
        <sys-log />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import loginLog from '../../components/log/loginLog.vue'
import operLog from '../../components/log/operLog.vue'
import sysLog from '../../components/log/sysLog.vue'
export default {
  name: 'Log',
  components: {
    loginLog,
    operLog,
    sysLog
  },
  data() {
    return {
      activeName: 'first'
    }
  },
  methods: {
    handleClick(tab, event) {
      // console.log(tab, event)
      this.activeName = tab.name
    }
  }
}
</script>
